import { useOfferTimer } from '../hooks/use-offer-timer';

interface CheckoutHeaderProps {
  onStartNow: () => void;
}

function pad(value: number): string {
  return String(value).padStart(2, '0');
}

export function CheckoutHeader({ onStartNow }: CheckoutHeaderProps) {
  const { minutes, seconds } = useOfferTimer();

  return (
    <header className="sticky top-0 z-20 flex h-[60px] items-center justify-between bg-mf-neutral-50 px-4">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-white shadow-[0_0_8px_rgba(26,22,19,0.03)]"
      />
      <div className="relative z-10 flex items-center gap-1">
        <TimeBlock value={pad(minutes)} unit="min" />
        <span className="px-0.5 text-lg font-bold leading-none text-mf-neutral-900">:</span>
        <TimeBlock value={pad(seconds)} unit="sec" />
      </div>
      <button
        type="button"
        onClick={onStartNow}
        className="relative z-10 flex h-10 items-center justify-center rounded-full bg-mf-green px-4 text-sm font-bold text-white transition-opacity hover:opacity-90"
      >
        Start Now
      </button>
    </header>
  );
}

function TimeBlock({ value, unit }: { value: string; unit: string }) {
  return (
    <div className="flex w-12 flex-col items-center rounded-lg bg-mf-neutral-50 py-1">
      <span className="font-display text-xl font-bold leading-6 text-mf-neutral-900">{value}</span>
      <span className="text-xs leading-4 text-mf-neutral-400">{unit}</span>
    </div>
  );
}
